/* 
Sample code: 
https://github.com/webrtc/samples/tree/gh-pages/src/content/peerconnection/pc1 
js/main.js
*/

import * as sdpUtils from "./sdpUtils.js";

const sleep = msec => new Promise(resolve => setTimeout(resolve, msec));

const options = {
  sdpSemantics: "unified-plan",
};
//  sdpSemantics: 'plan-b',
//  bundlePolicy: 'max-compat'

export async function localRTCPeerConnection(localStream, 
   gotRemoteStreams, gotRemoteTrack) { 
// gotRemoteSteams(), gotRemoteTrack() callback
  console.log('localRTCPeerConnection()');

  const localPeer = new RTCPeerConnection(options);
  const remotePeer = new RTCPeerConnection(options);

  localPeer.onicecandidate = async (e) => {
    await remotePeer.addIceCandidate(e.candidate);
  };
  localPeer.oniceconnectionstatechange = (e) => {
    console.log('localPeer ICE state:', localPeer.iceConnectionState);
  }; 

  localPeer.onconnectionstatechange = (e) => {
    console.log('localPeer state:', localPeer.connectionState);
  }; 

//  localPeer.onicecandidateerror = (e) => { }; 
//  localPeer.onicegatheringstatechange = (e) => { };
  localPeer.onnegotiationneeded = async (e) => { 
    console.log('localPeer onnegotiationneeded', e);
    await negotiate();
  };

//  localPeer.signalingstatechange = (e) => { };
//  localPeer.ondatachannel = (e) => { }; 

  localPeer.ontrack = (e) => { 
    // console.log('localPeer.ontrack()', e.stream[0]);
    console.log('localPeer.ontrack()', e);
  };

  remotePeer.onicecandidate = async (e) => {
    await localPeer.addIceCandidate(e.candidate);
  }; 

  remotePeer.oniceconnectionstatechange = (e) => {
    console.log('remotePeer ICE state:', remotePeer.iceConnectionState);
  }; 

  remotePeer.onconnectionstatechange = (e) => {
    console.log('remotePeer state:', remotePeer.connectionState);
  }; 

  remotePeer.ondatachannel = (e) => { 
    const rC = e.channel;
    rC.onmessage = (e) => {console.log('recvd:', e.data);}
    rC.onopen = (e) => {console.log('recv channel open', rC.label);}
    rC.onclose = (e) => {console.log('recv channel closed');}
  }; 

//  remotePeer.onicecandidateerror = (e) => { }; 
//  remotePeer.onicegatheringstatechange = (e) => {};

  remotePeer.onnegotiationneeded = async (e) => { 
    console.log('remotePeer onnegotioationneeded:', e);
  };

//  remotePeer.signalingstatechange = (e) => { };
  remotePeer.ontrack = (e) => { 
    console.log('remotePeer.ontrack()', e);

    if (e.streams && e.streams[0]) {
      gotRemoteStreams(e.streams);
    } else {
      gotRemoteTrack(e.track);
    }
  };

  async function negotiate () {
     const offer = await localPeer.createOffer();
/*
     const maxAverageBandwidth = 510000, ptime = 3;
     offer.sdp = sdpUtils.setOpusConfig(offer.sdp, 
       maxAverageBandwidth, ptime);
     console.log('Modified Offer SDP', offer.sdp);
*/
     await localPeer.setLocalDescription(offer);

     await remotePeer.setRemoteDescription(offer);
     const answer = await remotePeer.createAnswer()
     // console.log('Answer SDP\n', answer.sdp);

/*
     answer.sdp = sdpUtils.setOpusConfig(answer.sdp, 
       maxAverageBandwidth, ptime);
  //   console.log('Modified Answer SDP\n', answer.sdp);
*/

     await remotePeer.setLocalDescription(answer);
     await localPeer.setRemoteDescription(answer);

 } // end negotiate

 async function call() {
   // const secondLocalStream = new MediaStream();

   try { 
     localStream.getTracks().forEach(track => {
        // console.log(track);
        // if (track.kind === 'audio')
        localPeer.addTrack(track,localStream);
     }); // add tracks first!

     await negotiate();

   } catch(err) {console.error(err)};
 }

  await call();

  if (localPeer.connectionState) {
    console.log('localPeer connectionState', localPeer.connectionState);
    console.log('remotePeer connectionState', remotePeer.connectionState);
   } else console.log('connectionState is not supported');

  await sleep(1000);

  // console.log('return()');
  return ({localPeer: localPeer, remotePeer: remotePeer});

}


export function replaceTrack(peer, currentTrack, newTrack){
  
  // console.log('current ', currentTrack);

  try { 
    const sender = peer.getSenders().find( s => {
      // console.log('sender ', s.track);
      return s.track.id === currentTrack.id;
    });

    if (sender) {
      console.log('sender found', currentTrack, ' to ',  newTrack);
      sender.replaceTrack(newTrack);
    } else 
      console.log('sender not found');

  } catch (e) {console.error(e);}
  
}

export function removeTrack(peer, currentTrack){
  try {
    peer.getSenders().forEach(s => {
      if (!s.track){
        console.log ('empty sender removed');
        peer.removeTrack(s);
      } else if (s.track.id === currentTrack.id){
        console.log('sender found removing', currentTrack);
        peer.removeTrack(s);
      }
    });

  } catch(e) {console.error(e);}
}
